import { AppModalForm } from 'components/organisms';
import { AppModal, FormHeader, FormNavButtons } from 'components/molecules';
import { HeaderContainer } from 'components/organisms/AppForm/AppForm.styled';
import { commonTexts, settlementTexts } from 'consts/text';
import { formFields } from 'consts/form/formFields';
import { CurrencyInputElement } from 'components/molecules/FormElements/CurrencyInputElement/CurrencyInputElement';
import { useAppMutation } from 'services/reactQuery/useAppMutation';
import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { CommonFormProps } from 'types';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { useEditForm } from 'hooks/useEditForm/useEditForm';
import { useEffect } from 'react';
import { EditAdditionalCostCorrectionFormFields } from './EditAdditionalCostCorrectionModal.utils';

type ChildAddBillModalType = {
    isOpen: boolean;
    onCancel: () => void;
    grossSummary?: number;
    additionalCostId: string;
    correctionId: string;
} & Pick<CommonFormProps, 'mode' | 'initialValues'>;

export const EditAdditionalCostCorrectionModal = ({
    isOpen,
    additionalCostId,
    correctionId,
    grossSummary,
    onCancel,
}: ChildAddBillModalType) => {
    const { form, formInitialData, setFormData } =
        // @ts-ignore
        useEditForm<EditAdditionalCostCorrectionFormFields>();

    const { displaySuccess } = useSimpleNotification();

    const {
        mutate: editAdditionalCostCorrection,
        error: editAdditionalCostCorrectionError,
        isLoading: isAdditionalCostCorrectionLoading,
    } = useAppMutation(StaffHTTPService.settlements.editAdditionalCostCorrection, {
        key: ['EDIT_ADDITIONAL_COST_CORRECTION'],
        onSuccess: () => {
            displaySuccess(
                settlementTexts.children.successfullyEditAdditionalCostCorrectionMessage,
            );
            onCancel();
        },
        invalidateQueryKeys: [
            ['ADDITIONAL_COST_DETAILS'],
            ['ADDITIONAL_COST_LIST'],
            ['ADDITIONAL_COST'],
            ['CHILD_SETTLEMENT_BALANCE'],
            ['SETTLEMENTS'],
            ['CHILD_SETTLEMENT'],
            ['CHILD_SETTLEMENT_PAYMENT'],
        ],
    });

    useEffect(() => {
        if (grossSummary) {
            setFormData({
                grossAmount: grossSummary,
            });
        }
    }, [grossSummary, setFormData]);

    const onAddManualBillFinish = (billData: EditAdditionalCostCorrectionFormFields) => {
        editAdditionalCostCorrection({
            correctionId,
            additionalCostId,
            newGrossSummaryAmount: billData.grossAmount as number,
        });
    };

    return (
        <AppModal
            width={700}
            open={isOpen}
            onCancel={onCancel}
            isLoading={isAdditionalCostCorrectionLoading}
        >
            {/* @ts-ignore */}
            <AppModalForm<EditAdditionalCostCorrectionFormFields>
                name="addManualBill"
                error={editAdditionalCostCorrectionError}
                form={form}
                onFinish={onAddManualBillFinish}
            >
                <HeaderContainer isFormHeaderAtBottom={false}>
                    <FormHeader title="Edycja korekty dodatkowego kosztu" desktopTitleLevel={4} />
                </HeaderContainer>
                <CurrencyInputElement
                    name={formFields.grossAmount}
                    label={commonTexts.dataLabels.amount}
                />
                <FormNavButtons
                    formValuesBeforeChanges={formInitialData}
                    buttonText="Edytuj"
                    leftIcon={<IconDeviceFloppy size={20} />}
                />
            </AppModalForm>
        </AppModal>
    );
};
